<script lang="ts" setup>
import { AppIdentifier } from "@/shared/@types/AppIdentifier";
import StatusNotFoundError from "@/shared/components/StatusNotFoundError/StatusNotFoundError.vue";
</script>

<template>
  <StatusNotFoundError :button-link="`/${AppIdentifier.Registration}`" />
</template>
